import { initialKnmListByPlanFilterAdditionalFields } from '../constants/initialKnmListByPlanFilterAdditionalFields';
import { IKnmListByPlanFilter } from '../interfaces/IKnmListByPlanFilter';
import { IKnmListByPlanFilterExtraField } from '../interfaces/IKnmListByPlanFilterExtraField';

export function mapFilterAdditionalFields(filter: IKnmListByPlanFilter): IKnmListByPlanFilterExtraField[] {
  return initialKnmListByPlanFilterAdditionalFields.map<IKnmListByPlanFilterExtraField>(field => {
    switch (field.id) {
      case 'supervisionType': {
        return {
          ...field,
          isSelected: Boolean(filter.supervisionType),
        };
      }
      case 'objectsType': {
        return {
          ...field,
          isSelected: Boolean(filter.objectsType),
        };
      }
      case 'objectsKind': {
        return {
          ...field,
          isSelected: Boolean(filter.objectsKind),
        };
      }
      case 'objectsSubKind': {
        return {
          ...field,
          isSelected: Boolean(filter.objectsSubKind),
        };
      }
      case 'isHasRequirements': {
        return {
          ...field,
          isSelected: Boolean(filter.isHasRequirements),
        };
      }
      case 'isHasApproveDocs': {
        return {
          ...field,
          isSelected: Boolean(filter.isHasApproveDocs),
        };
      }
      case 'startDateBetween': {
        return {
          ...field,
          isSelected:
            (filter.startDateBetweenStart && filter.startDateBetweenStart.length > 0) ||
            (filter.startDateBetweenEnd && filter.startDateBetweenEnd.length > 0) ||
            false,
        };
      }
      case 'kinds': {
        return {
          ...field,
          isSelected: Boolean(filter.kinds),
        };
      }
      case 'events': {
        return {
          ...field,
          isSelected: Boolean(filter.events?.length),
        };
      }
      case 'isHasCollaboratingOrganization': {
        return {
          ...field,
          isSelected: Boolean(filter.isHasCollaboratingOrganization),
        };
      }
      case 'signed': {
        return {
          ...field,
          isSelected: filter.signed !== undefined,
        };
      }
      case 'isTest': {
        return {
          ...field,
          isSelected: Boolean(filter.isTest),
        };
      }
      default:
        return field;
    }
  });
}
